module.exports = __webpack_public_path__ + "static/media/tipsforattlyckas.83f1282c.jpg";